import { useTRPCAPI, useTRPCQuery } from '../../../../trpc/trpc';
import type { OutreachHomeData } from '../outreachTypes';
import { useRetry } from './useRetry';

/** `outreach.home` of the artist (frame a1, momentum t3). Realtime events read it again (`useOutreachRealtime`). */
export function useOutreachHome(accountId: number) {
  const trpcAPI = useTRPCAPI();
  const query = useTRPCQuery(trpcAPI.outreach.home.queryOptions({ accountId }, { retry: false }));
  const retry = useRetry(query.refetch);
  return {
    home: (query.data ?? undefined) as OutreachHomeData | undefined,
    isLoading: query.isLoading,
    error: query.error,
    retry,
  };
}
